import styled from 'styled-components'
import { easings } from '../../../styles/vars/easings.style'
import { animation } from '../../../styles/vars/animation.style'

export const SplitTextWrapper = styled.span`
  display: block;

  .split__mask {
    overflow: hidden;
  }

  .split__text {
    display: block;
    will-change: transform;
    transform: ${props => (props.show ? 'translateY(0)' : 'translateY(105%)')};
    transition: transform 0.5s ${easings.inOut.default};
    transition-delay: ${props =>
      props.show &&
      `calc(${props.delay}s + ${
        props.type === 'lines' ? animation.lineDuration : animation.wordDuration
      } * var(--splitTextDelay))`};

    br {
      display: inline-block;
    }
  }
`
